import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import nb from "./locales/nb";
import en from "./locales/en";
import "./i18n/usedTranslationKeys";
const supported = ["nb", "en"];

const resolvedLng = (() => {
  const stored = localStorage.getItem("lng");
  if (stored) return stored;

  const nav = (navigator.languages && navigator.languages[0]) || navigator.language || "nb";
  const base = String(nav).split("-")[0];
  const chosen = supported.includes(base) ? base : "nb";

  localStorage.setItem("lng", chosen);
  return chosen;
})();

const languages = { nb, en };

i18n
  .use(initReactI18next)
  .init({
    lng: resolvedLng,
    fallbackLng: "nb",
    // Remove ns: ["ns.translate"] and defaultNS: "ns.translate"
    // List your actual namespaces here or leave empty to load dynamically
    ns: Object.keys(en),
    defaultNS: "common", // Optional: set a default file
    debug: true,
    interpolation: {
      escapeValue: false,
    },
  })
  .then();

// Register each imported file as a separate namespace
Object.keys(languages).forEach((lang) => {
  const bundle = languages[lang as keyof typeof languages];
  Object.keys(bundle).forEach((ns) => {
    i18n.addResourceBundle(lang, ns, bundle[ns as keyof typeof bundle], true, true);
  });
});

export default i18n;
